import type { LicenseRow } from '../../types/onboarding'

function newLicenseeId(): string {
  return `L-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`
}

export function createEmptyBusinessLicense(): LicenseRow {
  return {
    licenseeId: newLicenseeId(),
    licenseeFirstName: '',
    licenseeLastName: '',
    npn: '',
    entity: 'BusinessEntity',
    fein: '',
    licenseState: '',
    licenseNumber: '',
    licenseType: 'Surplus Lines',
    residentState: true,
    status: 'Active',
    expirationDate: '',
    source: 'Manual',
    clientConfirmed: null,
    flaggedForReview: false,
    isDrlp: false,
  }
}

export function createEmptyIndividualLicense(): LicenseRow {
  return {
    licenseeId: newLicenseeId(),
    licenseeFirstName: '',
    licenseeLastName: '',
    npn: '',
    entity: 'Individual',
    fein: null,
    licenseState: '',
    licenseNumber: '',
    licenseType: 'Surplus Lines',
    residentState: true,
    status: 'Active',
    expirationDate: '',
    source: 'Manual',
    clientConfirmed: null,
    flaggedForReview: false,
    isDrlp: false,
    companyName: '',
  }
}

/** Blank individual marked as DRLP (added from the DRLP assignment step). */
export function createEmptyDrlpIndividual(): LicenseRow {
  return { ...createEmptyIndividualLicense(), isDrlp: true }
}
